module.exports = __webpack_public_path__ + "media/images/app_icons/android-icon-36x36-b6f7d46e5e359bf58f388eb679e49580.png";